<modal
  [id]="modalId"
  [header]="actionUi()?.header ?? ''"
  [headerIcon]="actionUi()?.headerIcon ?? ''"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-11/12 md:tw-w-[480px]'"
  [heightClass]="'tw-h-auto'"
  (onCloseModal)="onCancel()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-6 tw-pb-8">
    <p class="tw-text-gray-700 tw-text-base tw-leading-6 tw-font-normal tw-font-inter" [innerHTML]="message()"></p>

    @if (notifyLabel(); as label) {
    <label class="tw-flex tw-items-start tw-gap-2 tw-cursor-pointer">
      <input
        type="checkbox"
        class="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-rounded tw-border-gray-300 tw-accent-blue-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-300"
        [checked]="notifyByEmail()"
        (change)="onNotifyChange($event)"
      />
      <span class="tw-text-gray-900 tw-text-sm tw-leading-5 tw-font-medium tw-font-inter">{{ label }}</span>
    </label>
    }
  </div>

  <div slot="footer" class="tw-flex tw-justify-end tw-items-center tw-gap-2 tw-px-6 tw-pb-6">
    <button
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-border tw-border-gray-200 tw-text-gray-800 tw-bg-white hover:tw-bg-gray-100 tw-font-medium tw-rounded-lg tw-text-sm focus:tw-outline-none tw-px-4 tw-py-2 tw-font-inter"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-text-white focus:tw-ring-4 tw-font-medium tw-rounded-lg tw-text-sm focus:tw-outline-none tw-px-4 tw-py-2 tw-font-inter"
      [ngClass]="actionUi()?.confirmBtnClass"
      (click)="onConfirm()"
    >
      {{ actionUi()?.confirmLabel }}
    </button>
  </div>
</modal>
